import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6hzxpxjqta: FaireBrandEntity = {
  token: "b_6hzxpxjqta",
  type: "brand",
  name: "Sparkling Extras",
  avatarUrl:
    "https://cdn.faire.com/fastly/7a2b5dc9a3f5d5810e2c807ae2423ee9bf8aca3bfae6694d87dc718c9a3dd9c9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/cc183720807fc41112d5c6f1e379a8df862b03a3acd133057aa4e21fbf2e8b71.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7a2b5dc9a3f5d5810e2c807ae2423ee9bf8aca3bfae6694d87dc718c9a3dd9c9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cc183720807fc41112d5c6f1e379a8df862b03a3acd133057aa4e21fbf2e8b71.jpeg",
  location: "lake forest, CA, USA",
  minimumOrderDollars: 120,
  rating: 4.8,
  reviewCount: 33,
  isInsider: false,
  description:
    "Sparkling Extras is the sister brand of Miss Sparkling, expanding our vision to offer a dazzling collection of women's accessories. While Miss Sparkling is known for its young contemporary apparel, unique knitwear, and trend-setting designs, Sparkling Extras brings that same effortlessly cool vibe into the world of accessories.\n\nDesigned with the same attention to quality and style, Sparkling Extras offers a carefully curated selection of accessories—from statement earrings to chic handbags—perfect for the woman who loves to express her individuality. Our accessories, like Miss Sparkling’s apparel, are designed in Southern California and manufactured with care in our own factories in China, ensuring top-tier quality and affordability.\n\nWhether you're looking to elevate an everyday outfit or make a bold fashion statement, Sparkling Extras is your go-to source for stylish, on-trend accessories that stand out. We pride ourselves on evolving with the latest trends, and just like Miss Sparkling, we’re here to help you express your style with confidence and flair.\n\nDiscover the perfect finishing touches to any look with Sparkling Extras, where your style shines bright.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:41.179Z",
    importedBy: "entity-db-cli",
  },
};
